import { lazy } from 'react';
import { createBrowserRouter, Navigate, useParams } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { HomeView } from './views/HomeView';
import { LoginView } from './views/LoginView';
import { ProfileView } from './views/ProfileView';
import { NotFoundView } from './views/NotFoundView';

function TuneRedirect() {
  const { deckId } = useParams();
  return <Navigate to={`/deck/${deckId}`} replace />;
}

const PlaytestPage = lazy(() => import('./components/PlaytestPage').then(m => ({ default: m.PlaytestPage })));

function PlaytestRoute() {
  const { deckId } = useParams<{ deckId: string }>();
  return <PlaytestPage deckId={deckId!} />;
}

const DecksView = lazy(() => import('./views/DecksView').then(m => ({ default: m.DecksView })));
const MyDecksView = lazy(() => import('./views/MyDecksView').then(m => ({ default: m.MyDecksView })));
const DeckView = lazy(() => import('./views/DeckView').then(m => ({ default: m.DeckView })));
const AdminView = lazy(() => import('./views/AdminView').then(m => ({ default: m.AdminView })));
const AdminEngineGapsView = lazy(() => import('./views/AdminEngineGapsView').then(m => ({ default: m.AdminEngineGapsView })));
const SettingsView = lazy(() => import('./views/SettingsView').then(m => ({ default: m.SettingsView })));
const PodracerView = lazy(() => import('./views/PodracerView').then(m => ({ default: m.PodracerView })));
const GameSessionView = lazy(() => import('./views/GameSessionView').then(m => ({ default: m.GameSessionView })));
const LeaderboardView = lazy(() => import('./views/LeaderboardView').then(m => ({ default: m.LeaderboardView })));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <HomeView /> },
      { path: 'decks', element: <DecksView /> },
      { path: 'my-decks', element: <ProtectedRoute><MyDecksView /></ProtectedRoute> },
      { path: 'deck/:deckId', element: <DeckView /> },
      { path: 'deck/:deckId/playtest', element: <PlaytestRoute /> },
      { path: 'settings', element: <ProtectedRoute><SettingsView /></ProtectedRoute> },
      { path: 'admin', element: <ProtectedRoute requireAdmin><AdminView /></ProtectedRoute> },
      { path: 'admin/engine-gaps', element: <ProtectedRoute requireAdmin><AdminEngineGapsView /></ProtectedRoute> },
      { path: 'user/:userId', element: <ProfileView /> },
      { path: 'podracer', element: <PodracerView /> },
      { path: 'podracer/:sessionId', element: <GameSessionView /> },
      { path: 'leaderboard', element: <ProtectedRoute><LeaderboardView /></ProtectedRoute> },
      { path: 'tune/:deckId', element: <TuneRedirect /> },
      { path: '*', element: <NotFoundView /> },
    ],
  },
  {
    path: '/login',
    element: <LoginView />,
  },
  {
    path: '/register',
    element: <Navigate to="/login?tab=register" replace />,
  },
]);
